import React from 'react'
import Container from 'react-bootstrap/esm/Container'
import Card from 'react-bootstrap/esm/Card'
import CardHeader from 'react-bootstrap/esm/CardHeader'
import Col from 'react-bootstrap/esm/Col'
import Row from 'react-bootstrap/esm/Row'
import {get_server_url} from '../variables'
import ActivityEntry from './ActivityEntry'
import LockerRoom from './LockerRoom'
import Sponsor from './Sponsor'
import {CardBody} from 'react-bootstrap'
import {FIELD_TYPES} from '../types'

// How long each half of the left column stays on screen before shifting.
const LEFT_COLUMN_INTERVAL = 15000

function emptyFieldEntries()
{
	const entries = {}
	Object.keys(FIELD_TYPES).forEach((type) => entries[type] = [])
	return entries
}

class Activity extends React.Component	
{
	constructor(props)
	{
		super(props)
		this.state = {
			anyLockerRoom: false,
			entriesEvent: '',
			entriesMeating: '',
			entriesLockerRoom: {
				'sundthus': [],
				'jysk':	[],
				'jjd':	[],
				'ojm':	[],
				'bms':	[],
				'vb':	[],
				'dom': [],
				'hom': [],
			},
			entriesKultur: '',
			fullscreenEntry: null,
			entriesField: emptyFieldEntries(),
			showFields: false,
		}
	}
	translatePlace(type)
	{
		const map = {
			'sundthus': 'SundtHus',
			'jysk':	'Jysk',
			'jjd':	'JJD',
			'ojm':	'O. Jacobsen Maskinfabrik',
			'bms':	'BM Silo',
			'vb':	'Vestjysk Bank',
			'dom': 'Dameomklædning i kælderen',
			'hom': 'Herreomklædning i kælderen',
		}
		return map[type]
	}
	getActiveActivities()
	{
		var event = []
		var meating = []
		var lockerRoom = {
			'sundthus': [],
			'jysk':	[],
			'jjd':	[],
			'ojm':	[],
			'bms':	[],
			'vb':	[],
			'dom': [],
			'hom': [],
		}
		var kultur = []
		var field = emptyFieldEntries()
		fetch(get_server_url()+'/?cmd=get&active=true', {
			method: 'GET', // *GET, POST, PUT, DELETE, etc.
			cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
			mode: 'cors',
			headers: {
				'Content-Type': 'application/json',
			},
			redirect: 'follow', // manual, *follow, error
		})
			.then(response => response.json())
			.then(result =>
			{
				let any_locker_room = false
				let fullscreenEntry = null

				for (let i = 0; i < result.length; i++)
				{	
					const entry = result[i]
					
					// Check for fullscreen entries first
					if (entry.fullsize) 
					{
						fullscreenEntry = entry
						break // Stop processing other entries if we have a fullscreen one
					}
					
					let first_event = true
					let first_locker_room = true
					let first_culture = true
					let first_field = true
					switch (entry.type)
					{
						case 1: case '1': case 2: case '2':
							event.push(<ActivityEntry key={entry.id} json={entry} first={first_event} />)
							first_event = false
							break

						case 4: case '4':
							kultur.push(<ActivityEntry key={entry.id} json={entry} first={first_culture} />)
							first_culture = false
							break

						case 3: case '3':
							lockerRoom[entry['eventPlace']].push(<LockerRoom key={entry.id} json={entry} first={first_locker_room} />)
							first_locker_room = false
							any_locker_room = true
							break
						default:
							// The fodboldbaner, and any field added to FIELD_TYPES later.
							if (FIELD_TYPES[entry.type] !== undefined)
							{
								field[entry.type].push(<ActivityEntry key={entry.id} json={entry} first={first_field} />)
								first_field = false
							}
							break
					}
				}

				this.setState(
					{
						anyLockerRoom: any_locker_room,
						entriesEvent: event,
						entriesMeating: meating,
						entriesLockerRoom: lockerRoom,
						entriesKultur: kultur,
						fullscreenEntry: fullscreenEntry,
						entriesField: field,
					},
				)
			})
	}

	componentDidMount()
	{
		window.setInterval(() => this.getActiveActivities(), 30000)
		this.pageInterval = window.setInterval(
			() => this.setState((state) => ({showFields: !state.showFields})),
			LEFT_COLUMN_INTERVAL,
		)
		this.getActiveActivities()
		document.querySelector('body').style.overflow = 'hidden'

		const element = document.querySelector('.omklaedning-entries')
		if (element)
		{
			// Check if the content overflows

			this.scrollInterval = setInterval(() =>
			{
				if (element.scrollHeight > element.clientHeight - 50)
				{
					if (element.scrollTop <= 0) 
					{
						this.direction = 1
					}
					else if (element.scrollHeight - element.clientHeight === element.scrollTop) 
					{
						this.direction = -1
					}
				}

				element.scrollTop += this.direction * 5
			}, 100)

		}
	}

	renderHall()
	{
		return (
			<React.Fragment>
				<Card style={{'marginBottom': '10px'}} >
					<CardBody style={{textAlign: 'center'}}>
						<h1 style={{fontSize:'56px'}}>Hallen</h1>
					</CardBody>
				</Card>
				{this.state.entriesEvent}

				<Card
					style={{'marginBottom': '10px'}}
					className={(this.state.entriesKultur.length === 0 ? 'd-none' : '')}>
					<CardBody style={{textAlign: 'center'}}>
						<h1 style={{fontSize:'56px'}}>Kultursalen</h1>
					</CardBody>
				</Card>
				{this.state.entriesKultur}
			</React.Fragment>
		)
	}
	renderFields()
	{
		return Object.keys(FIELD_TYPES).map((type) => (
			<React.Fragment key={type}>
				<Card
					style={{'marginBottom': '10px'}}
					className={(this.state.entriesField[type].length === 0 ? 'd-none' : '')}>
					<CardBody style={{textAlign: 'center'}}>
						<h1 style={{fontSize:'56px'}}>{FIELD_TYPES[type]}</h1>
					</CardBody>
				</Card>
				{this.state.entriesField[type]}
			</React.Fragment>
		))
	}
	render()
	{
		// If we have a fullscreen entry, show only that
		if (this.state.fullscreenEntry)
		{
			return (
				<div className="fullscreen-entry">
					<Container fluid style={{height: '100vh', display: 'flex', flexDirection: 'column'}}>
						<Row style={{flex: '1', alignItems: 'center', justifyContent: 'center'}}>
							<Col className="text-center">
								<Card style={{border: 'none', backgroundColor: 'white', borderRadius: '15px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)'}}>
									<CardBody>
										<h1 style={{fontSize: '120px', fontWeight: 'bold', marginBottom: '30px'}}>
											{this.state.fullscreenEntry.eventName}
										</h1>
										{this.state.fullscreenEntry.subEventName && (
											<h2 style={{fontSize: '80px', color: '#6c757d'}}>
												{this.state.fullscreenEntry.subEventName}
											</h2>
										)}
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
					<Sponsor />
				</div>
			)
		}

		// Normal layout when no fullscreen entries
		const anyField = Object.keys(this.state.entriesField)
			.some((type) => this.state.entriesField[type].length > 0)
		const anyHall = this.state.entriesEvent.length > 0 || this.state.entriesKultur.length > 0

		// The left side shifts between hallen/kultursalen and the outdoor
		// fields, but only shifts when both have something to show. With
		// nothing booked anywhere it falls back to the hallen card.
		const showFields = anyField && (this.state.showFields || !anyHall)

		return (
			<div>
				<Container fluid className="entries">
					<Row>
						<Col className="hallen" xs={(this.state.anyLockerRoom ? 7 : 12)}>
							{/* The key restarts the css animation every time the column shifts. */}
							<div
								key={showFields ? 'fields' : 'hall'}
								className={'shifting-column ' + (showFields ? 'from-right' : 'from-left')}>
								{showFields ? this.renderFields() : this.renderHall()}
							</div>
						</Col>

						<Col id={'lockerRooms'} xs={(this.state.anyLockerRoom ? 5 : 0)} className={(this.state.anyLockerRoom ? '' : 'd-none')}>
							<Row>
								<Col className="omklaedning" xs={12}>
									<Card style={{marginBottom: '10px'}}>
										<CardBody style={{textAlign: 'center'}}>
											<h1 style={{fontSize:'56px'}}>Omklædning</h1>
										</CardBody>
									</Card>
									<div className="omklaedning-entries">
										{Object.keys(this.state.entriesLockerRoom).map((key) => (
											<Card className={(this.state.entriesLockerRoom[key].length === 0 ? 'd-none' : '')} key={key}>
												<CardHeader className={'pb-0'}>
													<h2 className={'mb-0'}>{this.translatePlace(key)}</h2>
												</CardHeader>
												<CardBody>
													{this.state.entriesLockerRoom[key]}
												</CardBody>
											</Card>
										))}
									</div>
								</Col>
							</Row>
						</Col>

					</Row>
				</Container>
				<Sponsor />

			</div>
		)
	}
}
/**
 * 
 * 
 * 'sundthus': 'SundtHus',
			'jysk':	'Jysk',
			'jjd':	'JJD',
			'ojm':	'O. Jacobsen Maskinfabrik',
			'bms':	'BM Silo',
			'vb':	'Vestjysk Bank',
			'dom': 'Dameomklædning i kælderen',
			'hom': 'Herreomklædning i kælderen',
 */

export default Activity
